import { ReferenceElement } from "./style";

export const ReferenceChunk = ({
  filename,
  btnref,
  index,
  redirectPath,
  pages,
  openModal,
}) => {
  return (
    <>
      <ReferenceElement.Wrapper
        ref={btnref}
        toggle={index % 2}
        // onClick={() => window.open(redirectPath, "_blank").focus()}
      >
        <ReferenceElement.Name>{filename}</ReferenceElement.Name>
        <ReferenceElement.Pages>
          {pages.map(({ page: p, ...pagedata }, ii) => (
            <ReferenceElement.Page key={p}>
              {p}
              {ii !== pages.length - 1 ? "," : ""}
            </ReferenceElement.Page>
          ))}
        </ReferenceElement.Pages>
        <ReferenceElement.LinkWrapper>
          <ReferenceElement.Link
            onClick={() => window.open(redirectPath, "_blank").focus()}
          >
            {">"}
          </ReferenceElement.Link>
          <ReferenceElement.Link
            onClick={() => openModal({ pages, filename, redirectPath })}
          >
            {"?"}
          </ReferenceElement.Link>
        </ReferenceElement.LinkWrapper>
      </ReferenceElement.Wrapper>
    </>
  );
};

export const ReferenceHeader = ({ docHeaderInfo }) => (
  <ReferenceElement.Wrapper
    style={{ backgroundColor: "transparent", fontWeight: 800 }}
  >
    <ReferenceElement.Name>{docHeaderInfo.documents}</ReferenceElement.Name>
    <ReferenceElement.Pages>
      <ReferenceElement.Page>{docHeaderInfo.pages}</ReferenceElement.Page>
    </ReferenceElement.Pages>
    <ReferenceElement.Link style={{ opacity: 0 }}>{">"}</ReferenceElement.Link>
  </ReferenceElement.Wrapper>
);
